import { render, staticRenderFns } from "./job.vue?vue&type=template&id=34607f55&scoped=true"
import script from "./job.vue?vue&type=script&lang=ts"
export * from "./job.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34607f55",
  null
  
)

export default component.exports